import LockTableMouseEventsHandlerState from "./LockTableMouseEventsHandlerState";

export default class LockTableRangeSelectedState extends LockTableMouseEventsHandlerState {
    constructor(mouseEventsHandler) {
        super(mouseEventsHandler);
    }

    mouseDown(evt, cell) {
        if (cell.getColIdx() == 0) {
            this.mouseEventsHandler.getSelectionController().clearSelection();
            this.mouseEventsHandler.setHoverState();
            return;
        }

        let mouseEventsHandler = this.mouseEventsHandler;
        cell.getRow().accept(
            {
                visitUserRow(cell) {
                    mouseEventsHandler.getSelectionController().clearSelection();
                    mouseEventsHandler.setDelayedSelectionState(function() {
                        mouseEventsHandler.setCellSelectionState(cell);
                    });
                },

                visitDetailsRow(cell) {
                    mouseEventsHandler.getSelectionController().clearSelection();
                    mouseEventsHandler.setDelayedSelectionState(function() {
                        let parentCell = cell.getRow().getParentRow().getCell(cell.getColIdx());
                        mouseEventsHandler.setCellSelectionState(parentCell);
                    });
                },

                visitDatesRow(cell) {
                    let singleDateSelected = mouseEventsHandler.getSelectionController().visitSelection({
                        visitCellSelection(selection) { return false; },
                        visitDateSelection(selection) { return selection.colMax == selection.colMin; },
                        visitRunnerSelection(selection) { return false; }
                    });
                    mouseEventsHandler.getSelectionController().clearSelection();
                    if (singleDateSelected) {
                        mouseEventsHandler.setColumnSelectionState(cell);
                    }
                    else
                        mouseEventsHandler.setDelayedSelectionState(function() {
                            mouseEventsHandler.setColumnSelectionState(cell);
                        });
                },

                visitRunnerRow(cell) {
                    let runnerPositionChanged = mouseEventsHandler.getSelectionController().visitSelection({
                        visitCellSelection(selection) { return false; },
                        visitDateSelection(selection) { return false; },
                        visitRunnerSelection(selection) { return true; }
                    });

                    //clear selection after selection type checked
                    mouseEventsHandler.getSelectionController().clearSelection();
                    if (runnerPositionChanged) {
                        mouseEventsHandler.setHoverState();
                        mouseEventsHandler.mouseOver(null, cell);
                    }
                    else {
                        mouseEventsHandler.setDelayedSelectionState(function() {
                            mouseEventsHandler.setHoverState();
                        });
                    }
                },

                visitInactiveRow(cell) {
                    mouseEventsHandler.getSelectionController().clearSelection();
                    mouseEventsHandler.setHoverState();
                }
            },
            cell
        );
    }

    mouseOver(evt, cell) {
        if (!this.mouseEventsHandler.getSelectionController().hasSelection()) {
            this.mouseEventsHandler.setHoverState();
            this.mouseEventsHandler.mouseOver(evt, cell);
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/LockTableRangeSelectedState.js